import type { RouteRecordRaw } from 'vue-router'
import LoginLayout from 'layouts/LoginLayout.vue'
import MainLayout from 'layouts/MainLayout.vue'
import ObserverLayout from 'layouts/ObserverLayout.vue'
import UserLoginPage from 'pages/UserLoginPage.vue'
import UserSettingsPage from 'pages/UserSettingsPage.vue'
import GameSelectionPage from 'pages/GameSelectionPage.vue'
import GameSetupPage from 'pages/GameSetupPage.vue'
import GameTrackerPage from 'pages/GameTrackerPage.vue'
import DatabaseSyncPage from 'pages/DatabaseSyncPage.vue'
import TeamSelectionPage from 'pages/TeamSelectionPage.vue'
import SetLineUpPage from 'pages/SetLineUpPage.vue'
import SprayChartPage from 'pages/SprayChartPage.vue'
import GameSummaryPage from 'pages/GameSummaryPage.vue'
import ErrorNotFound from 'pages/ErrorNotFound.vue'
import ObserverScoutPage from 'pages/ObserverScoutPage.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: LoginLayout,
    children: [
      { path: '', redirect: '/Observe/TEST' },
      { path: '/login', component: UserLoginPage, name:'Login' }
    ],
  },
  {
    path: '/',
    component: ObserverLayout,
    children: [
      {
        path: 'observe/:gameId', // The colon denotes a dynamic parameter
        name: 'ObserverScout',
        component: ObserverScoutPage
      }
    ],
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: 'GameSelection',
        name: 'GameSelection',
        component: GameSelectionPage,
        meta: { showHud: false }, // <-- This toggles the HUD off
      },
      {
        path: 'GameSetup',
        name: 'GameSetup',
        component: GameSetupPage,
        meta: { showHud: false }, // <-- This toggles the HUD off
      },
      {
        path: 'GameTracker',
        name: 'GameTracker',
        component: GameTrackerPage,
        meta: { showHud: true }, // <-- This toggles the HUD off
      },
      {
        path: 'DatabaseSync',
        name: 'DatabaseSync',
        component: DatabaseSyncPage,
        meta: { showHud: false }, // <-- This toggles the HUD off
      },
      {
        path: 'team-selection',
        name: 'team-selection',
        component: TeamSelectionPage,
        meta: { showHud: false }, // <-- This toggles the HUD off
      },
      {
        path: 'SetLineup',
        name: 'SetLineup',
        component: SetLineUpPage,
        meta: { showHud: false }, // <-- This toggles the HUD off
      },
      {
        path: 'SprayChart',
        name: 'SprayChart',
        component: SprayChartPage,
        meta: { showHud: false }, // <-- This toggles the HUD off
      },
      {
        path: 'GameSummary',
        name: 'GameSummary',
        component: GameSummaryPage,
        meta: { showHud: false }, // <-- This toggles the HUD off
      },
      {
        path: 'UserSettings',
        name: 'UserSettings',
        component: UserSettingsPage,
        meta: { showHud: false }, // <-- This toggles the HUD off
      },
    ],
  },
  // Always leave this as last one,
  {
    path: '/:catchAll(.*)*',
    component: ErrorNotFound,
  },
]

export default routes
